import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { CloseIcon } from '@fiverr-private/icons';
import { translate } from '@fiverr-private/i18n-react';
import IconButton from '../IconButton';
import { CloseButtonProps } from './types';
import { ICON_COLORS, ICON_SIZES } from './constants';
import classes from './index.module.scss';

const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ size = 'md', color = 'dark', shape = 'square', onClick, dataTestId, className: customClassName }, ref) => {
    const isLight = color === 'light';

    const className = classNames({ [classes.lightCloseButton]: isLight }, customClassName);

    return (
      <IconButton
        ref={ref}
        aria-label={translate('button.closeButton.close')}
        variant="ghost"
        shape={shape}
        size={size}
        onClick={onClick}
        data-testid={dataTestId}
        className={className}
        hasIntent={!isLight}
      >
        <CloseIcon size={ICON_SIZES[size]} color={ICON_COLORS[color]} />
      </IconButton>
    );
  }
);

CloseButton.displayName = 'CloseButton';

export default CloseButton;
